import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, Tab, Row, Col, Navbar, Nav } from 'react-bootstrap';
import ExtendedPlanColumns from './emailPlanColumns';
import { EmailPlanContext } from '../../utils/emailPlanContext';
import emailBannerImage from '../../assets/img/email-banner.svg';
import { SmoothScrollLink } from '../../utils/navUtils';
import './emailExtendedPlansWidget.scss';

function EmailExtendedPlansWidget() {
    const { i18n, t } = useTranslation();
    const { currentEmailPlan, setEmailPlan } = useContext(EmailPlanContext);
    const currentLanguage = i18n.language;

    const localizedPath = (path) => {
        const baseLangUrl = `/${currentLanguage}`;
        return baseLangUrl + path;
    };

    return (
        <div className="email-extended-plans-columns-wrapper">
            <Row className="mb-3">
                <Col md={12} className="text-center">
                    <h3 className="plans-subtitle">{t('titles.payment-cycle')}</h3>
                    <Tabs
                        id="plans-tabs"
                        activeKey={currentEmailPlan}
                        onSelect={(k) => setEmailPlan(k)}
                    >
                        <Tab eventKey="one" title={`1 ${t('titles.year')}`}>
                            <ExtendedPlanColumns period={1} />
                        </Tab>
                        <Tab
                            eventKey="two"
                            title={
                                <span>
                                    2 {t('titles.years')} <sup>-10%</sup>
                                </span>
                            }
                        >
                            <ExtendedPlanColumns period={2} />
                        </Tab>
                        <Tab
                            eventKey="three"
                            title={
                                <span>
                                    3 {t('titles.years')} <sup>-15%</sup>
                                </span>
                            }
                        >
                            <ExtendedPlanColumns period={3} />
                        </Tab>
                    </Tabs>
                </Col>
            </Row>
            <div className="email-banner">
                <Row>
                    <Col lg={2}>
                        <img className="email-image" src={emailBannerImage} alt="Email" />
                    </Col>
                    <Col lg={7}>
                        <h3>{t('banners.email-banner-title')}</h3>
                        <p>{t('banners.email-banner-text')}</p>
                    </Col>
                    <Col lg={3}>
                        <Nav className="contact-nav-button">
                            <SmoothScrollLink to={localizedPath('/hosting/web#page-top')}>
                                <Navbar.Brand>{t('buttons.learn-more')}</Navbar.Brand>
                            </SmoothScrollLink>
                        </Nav>
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default EmailExtendedPlansWidget;
